(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'notFound', {
            templateUrl:    'app/views/404.html',
            controller:     NotFoundController,
            controllerAs:   'vm'
        });


    /**
     * Handles all 404-related errors.
     *
     * Important: In case any significant changes are made to this component,
     * please re-test according to the https://victoriauniversity.atlassian.net/wiki/spaces/WT/pages/168198145/Blackbox+testing+guide+for+Topics+Programmes#BlackboxtestingguideforTopics&Programmes-Errorscreens
     *
     * @param {ng.IScope} $scope
     * @param {uirouter.UrlMatcherFactory} $urlMatcherFactory
     * @param {uirouter.UiRouter} $uiRouter
     * @param {ng.IWindowService} $window
     * @param {ToolkitTracker} ToolkitTracker
     * @param {MetaService} MetaService
     * @param {LoadingManager} LoadingManager
     * @param {LoggerFactory} LoggerFactory
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function NotFoundController(
        $scope,
        $urlMatcherFactory,
        $uiRouter,
        $window,
        ToolkitTracker,
        MetaService,
        LoadingManager,
        LoggerFactory,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'NotFoundController' );


        /** @const */

        // 404s default content information
        var DEFAULT_CONTENT = TEXTS.NOT_FOUND.DEFAULT,

        HTTP_STATUS_CODE    = 404;





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._      = TEXTS.NOT_FOUND;
        $scope.CONFIG = CONFIG;




        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        vm.content = undefined;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        vm.$onInit = function() {
            LoadingManager.loadingPending();

            initMetadata();

            defineContentFromUrl();
            track404sDetails();

            LoadingManager.loadingDone();
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function initMetadata() {
            MetaService.resetToDefaults();
            MetaService.disableIndexing();
            MetaService.addPrerenderHttpStatus( HTTP_STATUS_CODE );

            MetaService.updateTitleStructure({
                page: TEXTS.NOT_FOUND.META.TITLE
            });
            MetaService.updateDescriptionStructure( {
                site: null,
                page: TEXTS.NOT_FOUND.META.DESCRIPTION
            });
        }


        function defineContentFromUrl() {
            var allStates           = $uiRouter.stateRegistry.states,

            // Define all the states and their url patterns
            allStatesWithCustom404  = [
                {
                    state:      allStates[ CONFIG.STATES.STUDY_AREA ],
                    urlMatcher: $urlMatcherFactory.compile( '/' + CONFIG.ROUTES.STUDY_AREAS + '/*path' ),
                    content:    $scope._.STUDY_AREA
                },
                {
                    state:      allStates[ CONFIG.STATES.DEGREES ],
                    urlMatcher: $urlMatcherFactory.compile( '/' + CONFIG.ROUTES.DEGREES + '/*path' ),
                    content:    $scope._.DEGREE
                },
                {
                    state:      allStates[ CONFIG.STATES.POSTGRAD ],
                    urlMatcher: $urlMatcherFactory.compile( '/' + CONFIG.ROUTES.POSTGRADS + '/*path' ),
                    content:    $scope._.POSTGRAD
                },
                {
                    state:      allStates[ CONFIG.STATES.POSTGRAD ],
                    urlMatcher: $urlMatcherFactory.compile( '/' + CONFIG.ROUTES.GRADUATE_QUALS + '/*path' ),
                    content:    $scope._.GRADUATE_QUAL
                },
                {
                    state:      allStates[ CONFIG.STATES.POSTGRAD_AREA ],
                    urlMatcher: $urlMatcherFactory.compile( '/' + CONFIG.ROUTES.POSTGRAD_AREAS + '/*path' ),
                    content:    $scope._.POSTGRAD_AREA
                },
            ];

            var isContentAssigned = allStatesWithCustom404.some( function( state ) {
                if ( state.urlMatcher.exec( $uiRouter.urlService.path() ) ) {
                    vm.content = state.content;
                    return true;
                }
            });

            // Fallback to default
            if ( !isContentAssigned ) vm.content = DEFAULT_CONTENT;
        }


        /**
         *  Track:
         *  a) Last referring page URL - from within the app; or
         *  b) HTTP Referrer URL - if the last access was from an outside site; or
         *  c) No referrer - in case the URL was accessed directly.
         */
        function track404sDetails() {
            var successfulTransitions   = $uiRouter.globals.allSuccessTransitions,
            successfulTransitionsCount  = successfulTransitions.length,
            httpReferrer                = $window.document.referrer,
            offset                      = ( $uiRouter.stateService.current.name === CONFIG.STATES.SERVER_NOT_FOUND ) ? 2 : 1,
            finalReferrer               = '';

            if ( successfulTransitionsCount > offset ) {
                var stateService = successfulTransitions[ successfulTransitionsCount - ( offset + 1 ) ].router.stateService,
                targetStateName = successfulTransitions[ successfulTransitionsCount - ( offset + 1 ) ]._targetState._definition.name;

                finalReferrer = stateService.href( targetStateName, null, { absolute: true } );

                logger.debug( 'Referrer from the app', finalReferrer );
            } else if ( successfulTransitionsCount == offset && httpReferrer !== '' ) {
                finalReferrer = httpReferrer;
                logger.debug( 'Referrer from the other site %s!', finalReferrer );
            } else if ( successfulTransitionsCount == offset ) {
                logger.debug( 'Referrer does not exist - direct access!', finalReferrer );
            } else {
                logger.warn( "Cannot determine referrer's type, leaving it empty!", finalReferrer, successfulTransitions );
            }

            // Log #404 event to the GA
            try {
                ToolkitTracker.trackEvent( CONFIG.ANALYTICS.GTM_ID.NOT_FOUND, null, { referrer: finalReferrer });
            } catch ( err ) {
                logger.error( "Toolkit Tracker plugin has failed: ", err );
            }
        }


    }


    NotFoundController.$inject = [ '$scope', '$urlMatcherFactory', '$uiRouter', '$window', 'ToolkitTracker', 'MetaService', 'LoadingManager', 'LoggerFactory', 'TEXTS', 'CONFIG' ];
}());
